import {TranslateLoader} from '@ngx-translate/core';
import {Observable, of} from 'rxjs';

import * as translationEn from '../assets/i18n/en.json';
import * as translationNl from '../assets/i18n/nl.json';

const TRANSLATIONS = {
  en: translationEn,
  nl: translationNl,
};

export class CustomTranslateLoader implements TranslateLoader {
  constructor() {}

  public getTranslation(lang: string): Observable<any> {
    return of(TRANSLATIONS[lang]);
  }
}

export function translateFactory() {
  return new CustomTranslateLoader();
}
